import {
  CurrentSubscriptionResource,
  currentSubscriptionResourceSchema,
} from "@client/resources/CurrentSubscriptionResource";
import { ApiResponse } from "@typeDefinitions/Api";
import { APIMethods } from "@typeDefinitions/enums";
import { getDataAPI } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { object } from "yup";

export type GetCurrentSubscriptionResponse =
  ApiResponse<CurrentSubscriptionResource | null>;

const schema = object({
  data: currentSubscriptionResourceSchema.nullable().default(null),
});

export const getCurrentSubscriptionAPI =
  async (): Promise<GetCurrentSubscriptionResponse> => {
    const response = await getDataAPI(
      "/dietitian/subscription/current",
      APIMethods.GET,
    );

    return await schema
      .validate(response)
      .catch(logFetchValidateError("/dietitian/subscription/current"));
  };
